import React from 'react'
import Button from '../../uiKit/Button'


class SectionHomeCompleteSetupPrompt extends React.Component{


	componentDidMount(){
		if(window.analytics){
			window.analytics.page('Class',{subpage:'New Class Setup',sectionId:this.props.currentSection.id,title:this.props.currentSection.name})
		}
	}
	

	render(){
		return(
			<div className='sectionHome-completeSetupPrompt'>

				<div className='sectionHome-completeSetupPrompt-header'>
					<span className={'sectionHome-completeSetupPrompt-header-sectionName' + (this.props.sectionColor ? ` sectionHome-completeSetupPrompt-header-sectionName--${this.props.sectionColor}` : '')}>
						{this.props.sectionName}&nbsp; 
					</span>
					<span className='sectionHome-completeSetupPrompt-header-sectionName'>
					 is almost ready
					</span>
				</div>

				<div className='sectionHome-completeSetupPrompt-subtitle'>
					Finish setup by adding your students
				</div>

				<Button size='large' label='Add Students' onClickFunction={this.props.showBulkAddStudentsModal} />

				<div className='sectionHome-completeSetupPrompt-skip' onClick={this.props.dismissSetUpPrompt}>
					Skip this step
				</div>
			</div>
		)
	}
}


export default SectionHomeCompleteSetupPrompt


